import axios from "axios";
import endpointsService from "@/services/endpointsService";
import {store} from "@/store";
import Utils from "@/helpers/utils";
import type {LogData} from "@/models/log_data";

class MdmService {

  getAxiosInstance() {
    return axios.create({
      baseURL: endpointsService.getMdmEndpoint(),
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${store.jwtToken.value}`
      }
    });
  }

  async login(identifier: string, password: string, key: string) {
    const axiosInstance = this.getAxiosInstance();
    const {data} = await axiosInstance.post(`/apps/login`, {identifier, password, key});
    return data
  }

  async sendActivityLog(action: string, description: string) {
    try {
      const descriptionEdited = Utils.removeSpecialChars(description);
      const data: LogData = {
        action: action,
        description: descriptionEdited,
        meta: '',
        target: '',
        app_id: store.appId.value
      }
      const axiosInstance = this.getAxiosInstance();
      await axiosInstance.post('/apps/activity', data);
    } catch (e) {
      console.error(`>>> sendActivityLog error: ${e}`);
    }
  }
}

export default new MdmService()
